import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface UserSession {
    readonly 'custom:company'?: string;
    readonly email?: string;
    readonly expire?: number;
    readonly family_name?: string;
    readonly given_name?: string;
    readonly group?: string[];
    readonly sub?: string;
    readonly username?: string;
    readonly jwt?: string;
    readonly poolId?: string;
}

export interface UserInfoState {
    userInfo: UserSession | undefined;
}

const initialState: UserInfoState = {
    userInfo: undefined,
};

export const userInfoSlice = createSlice({
    name: 'userInfo',
    initialState,
    reducers: {
        updateUserInfo: (state, action: PayloadAction<UserSession>) => {
            state.userInfo = action.payload;
        },
        clearUserInfo(state) {
            state.userInfo = undefined;
        },
    },
});

export const userInfoReducer = userInfoSlice.reducer;
export const { updateUserInfo, clearUserInfo } = userInfoSlice.actions;
